import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  LOCALE_ID,
  OnInit,
  Renderer2,
  ViewChild,
} from "@angular/core";
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
} from "@angular/forms";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from "@angular/material/core";
import { AlertService } from "@sharedV11/services/alerts/alert/alert.service";
import moment from "moment";
import { Subject } from "rxjs";
import { filter, takeUntil } from "rxjs/operators";
import { AppDateAdapter } from "../../classes/dataAdapter/date-format.adapter";
import { Filter } from "../../classes/filters/filter";
import { Column } from "../../classes/tables/column";
import { table } from "../../classes/tables/table";
import { FilterService } from "../../services/filter/filter.service";
import { Translator } from "../../services/translator/translator.service";
import { FilterCalendarHeaderComponent } from "@sharedV11/components/filter-calendar-header/filter-calendar-header.component";
import { getLocale } from "@sharedV11/utils/factories";
import { resolveColumnLabel } from "../../utils/column-label.util";

export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MM-YYYY",
  },
  display: {
    dateInput: "DD-MM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY",
  },
};

@Component({
  selector: "app-filter",
  templateUrl: "./filter.component.html",
  styleUrls: ["./filter.component.scss"],
  providers: [
    {
      provide: DateAdapter,
      useClass: AppDateAdapter,
    },
    {
      provide: MAT_DATE_FORMATS,
      useValue: MY_FORMATS,
    },
    {
      provide: LOCALE_ID,
      useFactory: getLocale,
      deps: [Translator],
    },
    {
      provide: MAT_DATE_LOCALE,
      useFactory: getLocale,
      deps: [Translator],
    },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },
    // { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
  ],
  /* providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }], */
})
export class FilterComponent implements OnInit {
  private ngUnsubscribe = new Subject();

  private static readonly ASOCIAR_TX_TAXONOMY_COLUMN_NAMES = new Set<string>([]);

  readonly filterCalendarHeader = FilterCalendarHeaderComponent;

  private static readonly FILTER_SELECT_OPTION_NAME_AS_IS = new Set<string>([
    "TipoEntSal",
  ]);

  @Input() tableName: string;
  filters: Filter[] = [];
  translation: any;

  @ViewChild("filtersS") filtersS;

  @ViewChild("filterPanel", { read: ElementRef }) filterPanel: ElementRef;
  @ViewChild("filterButtonOption", { read: ElementRef })
  filterButtonOption: ElementRef;

  @ViewChild("columnButtonOption", { read: ElementRef })
  columnButtonOption: ElementRef;
  @ViewChild("ColumnPanelVisible", { read: ElementRef })
  columnPanelVisible: ElementRef;

  /** Input «Palabra clave» (debe sincronizarse antes de `filter()` en Aplicar filtros). */
  @ViewChild("keyValue", { read: ElementRef })
  keyValueInput: ElementRef<HTMLInputElement>;

  filterLength = 0;

  formControlListaFiltros: FormControl;
  formControlListaColumnas: FormControl;
  editFilterForm: FormGroup;

  panelFiltrosvisible = false;

  panelSelectorFiltrosvisible = false;
  panelColumnasvisible = false;
  numColconFiltro: any;

  /** Último evento do app-input-filter; `controlName` = formControlText (coluna), não o texto visível. */
  inputFilterData: { name?: string; value?: string; controlName?: string };

  constructor(
    private filterService: FilterService,
    private translator: Translator,
    private cdRef: ChangeDetectorRef,
    private renderer: Renderer2,
    private fb: FormBuilder,
    private mensajeAlerta: AlertService
  ) {
    this.clickOutSide();
  }

  table: table = {
    tableName: null,
    filterByApi: true,
    maxItems: 10,
    columns: [],
  };

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  labelFor(key: string | null | undefined): string {
    return resolveColumnLabel(key, this.translation);
  }

  placeholderFor(key: string | null | undefined): string {
    return this.labelFor(key);
  }

  ngOnInit(): void {
    this.initializeTranslate();
    // this.initializeEditFiltros();

    this.findTable();
    this.filterService.manageFilterGetDataDB(this.tableName);
    this.getTable();
    this.numColconFiltro = (this.table?.columns ?? []).filter((f) => f.filter == true);
  }

  // initializeEditFiltros() {
  //   //this.editFilterForm = new FormControl(this.table.columns.map(elem => elem.name));
  //   this.editFilterForm = this.fb.group({});
  // }
  generateInterfaceForm() {
    const columns = this.table?.columns ?? [];
    setTimeout(() => {
        this.editFilterForm = this.fb.group({});

        columns.forEach((column) => {
        if (column.filter == true) {
          if (column.type == "rangeDate") {
            let newFormGroup = this.fb.group({
              [column.name + "Start"]: [""],
              [column.name + "End"]: [""],
            });
            this.editFilterForm.addControl(column.name, newFormGroup);
          } else {
            /* mat-select con opción "--" usa [value]="null"; "" no coincide y el trigger queda vacío. */
            const initial = column.type === "select" ? null : "";
            const control = new FormControl(initial);

            if (column.type === 'select' && column?.filterOptionsPreSeLected && column?.filterOptions?.selectOptions?.length) {
              control.setValue(column.filterOptions?.selectOptions[0]?.value, { emitModelToViewChange: true, emitEvent: true });
            }

            this.editFilterForm.addControl(column.name, control);
            // this.editFilterForm.registerControl()
          }
        }
      });
        this.applyFilterValuesToForm();
        if (this.tableName === "asociarTX") {
          this.updateAsociarTxTaxonomyFiltersDisabledState();
        }
        this.cdRef.detectChanges();
    }, 500);
  }

  /**
   * Tras regenerar el formulario (p. ej. al volver a emitir table$), repone los controles
   * desde los filtros activos para que coincidan con los chips y la petición API.
   * @param reselectMatSelectIfUnchanged Si true (tras Aplicar Filtros), fuerza null→valor en
   *   mat-select cuando el modelo ya coincide, para corregir trigger vacío (bug Material).
   */
  private applyFilterValuesToForm(reselectMatSelectIfUnchanged = false): void {
    if (!this.editFilterForm || !this.table?.columns?.length || !this.filters?.length) {
      return;
    }
    for (const filt of this.filters) {
      if (!filt || filt.name === "keyValue") {
        continue;
      }
      const column = this.table.columns.find(
        (c) =>
          c.filter &&
          (c.filterApi === filt.filterApi || c.name === filt.name)
      );
      if (!column) {
        continue;
      }
      const ctrl = this.editFilterForm.get(column.name);
      if (!ctrl) {
        continue;
      }
      this.patchFilterControlFromFilter(column, filt, ctrl, reselectMatSelectIfUnchanged);
    }
  }

  private resolveSelectStoredValue(column: Column, stored: unknown): unknown {
    const opts = column.filterOptions?.selectOptions;
    if (!opts?.length) {
      return stored;
    }
    const found = opts.find(
      (o) => o.value === stored || String(o.value) === String(stored)
    );
    return found ? found.value : stored;
  }

  private patchFilterControlFromFilter(
    column: Column,
    filt: Filter,
    ctrl: AbstractControl,
    reselectMatSelectIfUnchanged = false
  ): void {
    const raw = filt.value;
    const opts = { emitEvent: false };

    switch (column.type) {
      case "select": {
        if (raw === "" || raw == null) {
          ctrl.setValue(null, opts);
        } else {
          const resolved = this.resolveSelectStoredValue(column, raw);
          const cur = ctrl.value;
          const sameResolved =
            cur === resolved ||
            (cur != null &&
              resolved != null &&
              String(cur) === String(resolved));
          /*
           * MatSelect só corre _setSelectionByValue quando newValue !== this._value.
           * O FormControl pode manter "1" e o chip estar certo, mas o trigger vazio.
           * Só forçamos null→resolved após Aplicar (reselectMatSelectIfUnchanged).
           */
          if (reselectMatSelectIfUnchanged && sameResolved) {
            ctrl.setValue(null, { emitEvent: false });
          }
          ctrl.setValue(resolved, opts);
        }
        break;
      }
      case "multiselect": {
        const parts = String(raw ?? "")
          .split(",")
          .map((s) => s.trim())
          .filter((s) => s !== "");
        const resolved = parts.map((p) =>
          this.resolveSelectStoredValue(column, p)
        );
        ctrl.setValue(resolved, opts);
        break;
      }
      case "number": {
        if (raw === "" || raw === null || raw === undefined) {
          ctrl.setValue("", opts);
        } else {
          const n = Number(raw);
          ctrl.setValue(Number.isNaN(n) ? raw : n, opts);
        }
        break;
      }
      case "date": {
        const m = moment(raw, ["YYYY/MM/DD", "YYYY-MM-DD", "DD/MM/YYYY"], true);
        ctrl.setValue(m.isValid() ? m : raw, opts);
        break;
      }
      case "rangeDate": {
        const grp = ctrl as FormGroup;
        const str = String(raw ?? "");
        const parts = str.split(/\s*-\s*/).map((p) => p.trim());
        if (parts.length >= 1) {
          const m1 = moment(parts[0], "DD/MM/YYYY", true);
          if (m1.isValid()) {
            grp.get(column.name + "Start")?.setValue(m1, opts);
          }
        }
        if (parts.length >= 2) {
          const m2 = moment(parts[1], "DD/MM/YYYY", true);
          if (m2.isValid()) {
            grp.get(column.name + "End")?.setValue(m2, opts);
          }
        }
        break;
      }
      case "inputFilter":
      case "string":
      case "hour":
      default:
        ctrl.setValue(raw ?? "", opts);
        break;
    }
  }

  get fEdit() {
    return this.editFilterForm.controls;
  } //Editor

  /*labelFor(key: string): string {
    if (!key) {
      return "";
    }
    return this.translation?.[key] ?? key;
  }

  placeholderFor(key: string): string {
    if (!key) {
      return "";
    }
    return this.translation?.[key] ?? key;
  }

  /** compareWith para mat-select (evita erro quando recebe valor inválido). */
  compareWithFilter = (a: any, b: any): boolean => {
    if (a === b) return true;
    if (a == null && b == null) return true;
    if (a == null || b == null) return false;
    const va = typeof a === "object" ? (a.value ?? a.pkId ?? a.id ?? a) : a;
    const vb = typeof b === "object" ? (b.value ?? b.pkId ?? b.id ?? b) : b;
    if (va === vb) return true;
    return String(va) === String(vb);
  };

  getFilterDisplayValue(filter: Filter): string {
    if (!filter) {
      return "";
    }
    if (filter.show != null && filter.show !== "") {
      return String(filter.show);
    }
    return filter.value != null && filter.value !== ""
      ? String(filter.value)
      : "";
  }

  /** Sin ?./?? en plantilla (parser Angular 11). */
  filterStringMaxLength(columnDB: Column): number | null {
    const fo = columnDB && columnDB.filterOptions;
    if (!fo) {
      return null;
    }
    const ml = (fo as { maxLength?: unknown }).maxLength;
    if (ml == null || typeof ml !== "number" || Number.isNaN(ml)) {
      return null;
    }
    return ml;
  }

  selectOptionsForFilterColumn(columnDB: Column): any[] {
    const fo = columnDB && columnDB.filterOptions;
    const opts = fo && fo.selectOptions;
    return Array.isArray(opts) ? opts : [];
  }

  hasFilterSelectOptions(columnDB: Column): boolean {
    return this.selectOptionsForFilterColumn(columnDB).length > 0;
  }

  getEditFilterControlValue(controlName: string): unknown {
    if (!this.editFilterForm) {
      return undefined;
    }
    const c = this.editFilterForm.get(controlName);
    return c ? c.value : undefined;
  }

  getSelectOptionLabel(
    columnDB: Column,
    option: { name?: string | number; value?: unknown } | null | undefined
  ): string {
    if (option == null) {
      return "";
    }
    const dict = this.translation;
    if (
      columnDB?.translateSelectLabel &&
      columnDB.name === "TipoProducto" &&
      option.value != null &&
      String(option.value).trim() !== ""
    ) {
      const v = String(option.value).trim();
      const trKeyByValue: Record<string, string> = {
        "1": "TipoProductoEntrada",
        "2": "TipoProductoPromocion",
        "3": "TipoProductoTAbonado",
      };
      const trKey = trKeyByValue[v];
      if (trKey && dict != null && typeof dict === "object") {
        const t = dict[trKey];
        if (typeof t === "string" && t.trim() !== "") {
          return t;
        }
      }
      const tipoProductoFallback: Record<string, string> = {
        "1": "Entrada",
        "2": "Promoción",
        "3": "T Abonado",
      };
      if (tipoProductoFallback[v]) {
        return tipoProductoFallback[v];
      }
    }

    const raw = option.name;
    if (raw === null || raw === undefined || raw === "") {
      return "";
    }
    const nameStr = String(raw);
    const colName = columnDB?.name;
    if (
      colName &&
      FilterComponent.FILTER_SELECT_OPTION_NAME_AS_IS.has(colName)
    ) {
      return nameStr;
    }
    if (dict == null || typeof dict !== "object") {
      return nameStr;
    }
    const translated = dict[nameStr];
    if (typeof translated === "string" && translated.trim() !== "") {
      return translated;
    }
    return nameStr;
  }

  isWideFilter(columnDB: Column): boolean {
    return this.tableName === "centrosCosteTX" && columnDB?.name === "Descripcion";
  }

  isHalfWidthFilter(columnDB: Column): boolean {
    if (this.tableName !== "centrosCosteTX") return false;
    return columnDB?.name === "Codigo" || columnDB?.name === "Nombre";
  }

  isAsociarTxProductoNombreWideFilter(columnDB: Column): boolean {
    if (this.tableName !== "asociarTX") {
      return false;
    }
    return (
      columnDB?.name === "ProductoNombre" ||
      columnDB?.name === "TXRevenueCategory"
    );
  }

  private getAnoVigente(): number {
 
    const fechaInicioFilter = this.filters.find((f) => f.name === "FechaInicio");
    if (fechaInicioFilter?.value) {
      const parsed = moment(fechaInicioFilter.value, "YYYY/MM/DD", true);
      if (parsed.isValid()) {
        return parsed.year();
      }
    }
    return moment().year();
  }

  get minFechaPicker(): Date {
    const baseYear = this.getAnoVigente();
    return moment({ year: baseYear - 2, month: 0, day: 1 }).startOf("day").toDate();
  }

  get maxFechaPicker(): Date {
    const baseYear = this.getAnoVigente();
    return moment({ year: baseYear + 2, month: 11, day: 31 }).endOf("day").toDate();
  }

  async initializeTranslate() {
    this.translation = this.translator.GetTranslations();
  }
  initializeFiltros() {
  
    this.formControlListaFiltros = new FormControl(
      this.table.columns
        .filter((elem) => elem.filter && elem.filterActive !== "")
        .map((elem) => elem.name)
    );
  }
  private columnSeleccionadaEnPanelColumnas(elem: any): boolean {
    if (!elem || elem.type === "actions") {
      return false;
    }
    return !!(
      elem.column === true &&
      elem.columnActive !== "" &&
      elem.columnActive != null
    );
  }

  initializeColumnas() {
    this.formControlListaColumnas = new FormControl(
      this.table.columns
        .filter((elem) => this.columnSeleccionadaEnPanelColumnas(elem))
        .map((elem) => elem.name)
    );
  }

  findTable() {
    this.filterService.findTable(this.tableName);
  }

  changeColumns() {
    this.filterService.changeTable(this.table);
  }

  getTable() {
    this.filterService.table$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((data) => {
        this.table = data;
        if (this.table) {
          if (this.table.columns != null) {
            this.initializeFiltros();
            this.initializeColumnas();
            // this.initializeEditFiltros();
            this.generateInterfaceForm();
            this.filterLength = this.filterLenghtWithoutAColumn();
            this.cdRef.detectChanges();
          }
        }
      });
  }

  MostrarFiltros() {
    this.panelSelectorFiltrosvisible = !this.panelSelectorFiltrosvisible;
    this.panelColumnasvisible = false;
  }
  MostrarColumnas() {
    this.panelColumnasvisible = !this.panelColumnasvisible;
    this.panelSelectorFiltrosvisible = false;
  }
  
  compareOptionValue = this.compareWithFilter;

  onSelectFilterChange(controlName: string, value: any): void {
    const ctrl = this.editFilterForm.get(controlName);
    if (ctrl) {
      if (value !== undefined) {
        ctrl.setValue(value, { emitEvent: false });
        ctrl.updateValueAndValidity();
      }
    }
    if (this.tableName === "asociarTX" && controlName === "TieneTX") {
      if (value === "0" || value === 0) {
        this.clearAsociarTxTaxonomyFilterControls();
      }
      this.updateAsociarTxTaxonomyFiltersDisabledState();
      this.cdRef.detectChanges();
    }
  }

  private isAsociarTxTaxonomyFilterColumn(columnDB: Column): boolean {
    return (
      this.tableName === "asociarTX" &&
      FilterComponent.ASOCIAR_TX_TAXONOMY_COLUMN_NAMES.has(columnDB?.name)
    );
  }

  /** Para `app-input-filter` (form interno): desactivar cando TieneTX = 0. */
  isAsociarTxTaxonomyFilterDisabled(columnDB: Column): boolean {
    if (!this.isAsociarTxTaxonomyFilterColumn(columnDB)) {
      return false;
    }
    const v = this.editFilterForm?.get("TieneTX")?.value;
    return v === "0" || v === 0 || String(v ?? "") === "0";
  }

  /** Desactiva/restaura controles do formulario reactivo (string/number/select) alinhado a TieneTX. */
  private updateAsociarTxTaxonomyFiltersDisabledState(): void {
    if (this.tableName !== "asociarTX" || !this.editFilterForm) {
      return;
    }
    const tiene = this.editFilterForm.get("TieneTX")?.value;
    const off =
      tiene === "0" || tiene === 0 || String(tiene ?? "") === "0";
    for (const name of FilterComponent.ASOCIAR_TX_TAXONOMY_COLUMN_NAMES) {
      const ctrl = this.editFilterForm.get(name);
      if (!ctrl) {
        continue;
      }
      if (off) {
        ctrl.disable({ emitEvent: false });
      } else {
        ctrl.enable({ emitEvent: false });
      }
    }
  }

  private clearAsociarTxTaxonomyFilterControls(): void {
    if (this.tableName !== "asociarTX" || !this.editFilterForm || !this.table?.columns) {
      return;
    }
    for (const name of FilterComponent.ASOCIAR_TX_TAXONOMY_COLUMN_NAMES) {
      const col = this.table.columns.find((c) => c.name === name);
      const ctrl = this.editFilterForm.get(name);
      if (!col || !ctrl) {
        continue;
      }
      if (col.type === "select") {
        ctrl.setValue(null, { emitEvent: false });
      } else if (col.type === "number") {
        ctrl.setValue("", { emitEvent: false });
      } else {
        ctrl.setValue("", { emitEvent: false });
      }
    }
  }

  private syncAsociarTxFormWithTieneTxRule(): void {
    if (this.tableName !== "asociarTX" || !this.editFilterForm) {
      return;
    }
    const tiene = this.editFilterForm.get("TieneTX")?.value;
    if (tiene === "0" || tiene === 0 || String(tiene ?? "") === "0") {
      this.clearAsociarTxTaxonomyFilterControls();
    }
    this.updateAsociarTxTaxonomyFiltersDisabledState();
  }

  AplicarFiltros() {
    this.mensajeAlerta.limpiar();
    if (this.tableName === "asociarTX") {
      this.syncAsociarTxFormWithTieneTxRule();
    }
    const kwFromDom = this.keyValueInput?.nativeElement
      ? String(this.keyValueInput.nativeElement.value ?? "").trim()
      : "";
    this.filterByAll(kwFromDom, { skipTableReload: true });
    this.filterByInputFilter();
    this.manageChipsFilter();
    this.filterService.filter(this.tableName, this.filters);

    this.applyFilterValuesToForm(true);
    Promise.resolve().then(() => {
      this.applyFilterValuesToForm(true);
      this.cdRef.detectChanges();
    });
  }
  removeFilter(filter) {
    let filterIndex = this.filters.findIndex(
      (find) => find.filterApi == filter.filterApi
    );
    let filterIndexKey = this.filters.findIndex(
      (find) => find.name == "keyValue"
    );
    if (filterIndexKey != -1) {
      this.filters[filterIndexKey].value = "";
      this.filterByAll(this.filters[filterIndexKey].value);
    } else {
      this.removeDataInput(filter.filterApi);
    }
    this.filters.splice(filterIndex, 1);

    this.filterService.filter(this.tableName, this.filters);
  }

  removeDataInput(name) {
    const editedColumn = this.table.columns.find(
      (find) => find.filterApi == name || find.name == name
    );

    if (!editedColumn) {
      return;
    }

    const element = <HTMLInputElement>document.getElementById(editedColumn.name);

    if (element) {
      element.value = "";
      //this.fEdit[nameColumn].setValue(" ")
      (<HTMLInputElement>(
        document.getElementById(editedColumn?.name + "-hidden")
      )).value = "";
    }

    if (
      (editedColumn.type === "select" || editedColumn.type === "inputFilter") &&
      editedColumn.filterOptionsPreSeLected &&
      editedColumn.filterOptions?.selectOptions?.length
    ) {
      this.fEdit[editedColumn.name].setValue(editedColumn.filterOptions.selectOptions[0]?.value);
    } else {
      this.fEdit[editedColumn.name].reset();
    }
  }
  filterByAll(
    value: string,
    options?: { skipTableReload?: boolean }
  ) {
    this.mensajeAlerta.limpiar();
    let filterIndex = this.filters.findIndex((find) => find.name == "keyValue");

    // console.log('filterByAll => filtes :: ', this.filters[filterIndex]);

    if (filterIndex != -1) {
      if (value != "") {
        this.filters[filterIndex].value = value;
        this.filters[filterIndex].show = value;
        this.filterService.filterByAll(this.filters[filterIndex]);
      } else {
        this.filters[filterIndex].value = value;
        this.filterService.filterByAll(this.filters[filterIndex]);
        this.filters.splice(filterIndex, 1);
      }
    } else {
      if (value != "") {
        let filterToAdd = new Filter();
        filterToAdd.value = value;
        filterToAdd.show = value;
        filterToAdd.name = "keyValue";
        filterToAdd.translation = "PalabraClave";
        filterToAdd.filterApi = "keyValue";
        this.pushInFilterToAdd(filterToAdd);
        this.filterService.filterByAll(filterToAdd);
      }
    }
    if (
      !options?.skipTableReload &&
      this.table?.filterByApi &&
      this.tableName
    ) {
      this.filterService.filter(this.tableName, this.filters);
    }
  }
  manageChipsFilter() {
    this.table.columns.map((column) => {
      let filterIndex = this.filters.findIndex(
        (find) => find.filterApi == column.filterApi
      );

      if (filterIndex != -1) {
        if (
          this.fEdit[column.name].value != "" &&
          this.fEdit[column.name].value != undefined
        ) {
          if (column.type == "number") {
            if (isNaN(this.fEdit[column.name].value)) {
              this.filters.splice(filterIndex, 1);
            } else {
              this.filters[filterIndex].value = this.fEdit[column.name].value;
              this.filters[filterIndex].show = this.fEdit[column.name].value;
            }
          } else if (column.type == "rangeDate") {
            if (
              moment(
                this.fEdit[column.name].value[column.name + "Start"]
              ).isValid()
            ) {
              if (this.fEdit[column.name].value[column.name + "End"] != null) {
                if (
                  moment(this.fEdit[column.name].value[column.name + "Start"]) <
                  moment(this.fEdit[column.name].value[column.name + "End"])
                ) {
                  this.filters[filterIndex].value =
                    moment(
                      this.fEdit[column.name].value[column.name + "Start"]
                    ).format("DD/MM/YYYY") +
                    " - " +
                    moment(
                      this.fEdit[column.name].value[column.name + "End"]
                    ).format("DD/MM/YYYY");
                  this.filters[filterIndex].show =
                    this.fEdit[column.name].value;
                }
              } else {
                if (
                  moment(this.fEdit[column.name].value[column.name + "Start"]) <
                  moment()
                ) {
                  this.filters[filterIndex].value =
                    moment(
                      this.fEdit[column.name].value[column.name + "Start"]
                    ).format("DD/MM/YYYY") +
                    " - " +
                    moment().format("DD/MM/YYYY");
                  this.filters[filterIndex].show =
                    this.fEdit[column.name].value;
                }
              }
            } else {
              this.filters.splice(filterIndex, 1);
            }
          } else if (column.type == "date") {
            if (moment(this.fEdit[column.name].value).isValid()) {
              this.filters[filterIndex].value = moment(
                this.fEdit[column.name].value
              ).format("YYYY-MM-DD");
              this.filters[filterIndex].show = moment(
                this.fEdit[column.name].value
              ).format("YYYY-MM-DD");
            } else {
              this.filters.splice(filterIndex, 1);
            }
          } else if (column.type == "select") {
            this.filters[filterIndex].value = this.fEdit[column.name].value;
            const v = this.filters[filterIndex].value;
            const opt = column.filterOptions?.selectOptions?.find(
              (o) => o.value == v || String(o.value) === String(v)
            );
            this.filters[filterIndex].show = opt?.name ?? v;
          } else if (column.type == "inputFilter") {
            const val = this.fEdit[column.name].value;
            if (val == null || val === "" || val === "-1") {
              this.filters.splice(filterIndex, 1);
            } else {
              this.filters[filterIndex].value = val;
              const opt = column.filterOptions?.selectOptions?.find(
                (o) => o.value == val || String(o.value) === String(val)
              );
              this.filters[filterIndex].show = opt?.name ?? val;
            }
          } else {
            this.filters[filterIndex].value = this.fEdit[column.name].value;
            this.filters[filterIndex].show = this.fEdit[column.name].value;
          }
        } else {
          this.filters.splice(filterIndex, 1);
        }
      } else {
        if (column.name != "Actions" && column.filter) {
          if (
            this.fEdit[column.name].value != "" &&
            this.fEdit[column.name].value != undefined
          ) {
            if (column.type == "number") {
              if (!isNaN(this.fEdit[column.name].value)) {
                let filterToAdd = this.createNewFilter(column);
                this.pushInFilterToAdd(filterToAdd);
              }
            } else if (column.type == "rangeDate") {
              if (
                moment(
                  this.fEdit[column.name].value[column.name + "Start"]
                ).isValid()
              ) {
                let filterToAdd = this.createNewFilter(column);

                this.pushInFilterToAdd(filterToAdd);
              }
            } else if (column.type == "date") {
              if (moment(this.fEdit[column.name].value).isValid()) {
                let filterToAdd = this.createNewFilter(column);

                this.pushInFilterToAdd(filterToAdd);
              }
            } else if (column.type == "multiselect") {
              if (this.fEdit[column.name].value) {
                let filterToAdd = this.createNewFilter(
                  column,
                  column.filterOptions
                );
                this.pushInFilterToAdd(filterToAdd);
              }
            } else if (column.type == "select") {
              const val = this.fEdit[column.name].value;
              if (val != null && val !== "") {
                let filterToAdd = this.createNewFilter(column);
                this.pushInFilterToAdd(filterToAdd);
              }
            } else if (column.type == "inputFilter") {
              const val = this.fEdit[column.name].value;
              if (val != null && val !== "" && val !== "-1") {
                let filterToAdd = this.createNewFilter(column);
                this.pushInFilterToAdd(filterToAdd);
              }
            } else {
              if (
                this.fEdit[column.name].value &&
                this.fEdit[column.name].value.trim() != ""
              ) {
                let filterToAdd = this.createNewFilter(column);
                this.pushInFilterToAdd(filterToAdd);
              }
            }
          }
        }
      }
    });
  }

  pushInFilterToAdd(data) {
    if (data != null) {
      this.filters.push(data);
    }
  }

  createNewFilter(column: Column, options?) {
    let filterToAdd = new Filter();

    if (column.type == "rangeDate") {
      if (this.fEdit[column.name].value[column.name + "End"] != null) {
        filterToAdd.value =
          moment(this.fEdit[column.name].value[column.name + "Start"]).format(
            "DD/MM/YYYY"
          ) +
          " - " +
          moment(this.fEdit[column.name].value[column.name + "End"]).format(
            "DD/MM/YYYY"
          );
        filterToAdd.show = filterToAdd.value;
      } else {
        if (
          moment(this.fEdit[column.name].value[column.name + "Start"]) <
          moment()
        ) {
          filterToAdd.value =
            moment(this.fEdit[column.name].value[column.name + "Start"]).format(
              "DD/MM/YYYY"
            ) +
            " - " +
            moment().format("DD/MM/YYYY");
          filterToAdd.show = filterToAdd.value;
        } else {
          return null;
        }
      }
    } else if (column.type == "date") {
      // API espera formato YYYY/MM/DD (mesmo formato que retorna)
      filterToAdd.value = moment(this.fEdit[column.name].value).format(
        "YYYY/MM/DD"
      );
      filterToAdd.show = moment(this.fEdit[column.name].value).format(
        "DD/MM/YYYY"
      );
    } else if (column.type == "select") {
      filterToAdd.value = this.fEdit[column.name].value;
      const selOpt = column.filterOptions?.selectOptions?.find(
        (o) => o.value == filterToAdd.value || String(o.value) === String(filterToAdd.value)
      );
      filterToAdd.show = selOpt
        ? this.getSelectOptionLabel(column, selOpt)
        : filterToAdd.value;
    } else if (column.type == "multiselect") {

      const selectOptions = options?.selectOptions ?? column?.filterOptions?.selectOptions ?? [];
      let listaidstring = [];
      let listanombres = [];
      this.fEdit[column.name].value.forEach((element) => {
        // listaidstring.push(parseInt(element));
        listaidstring.push(element);
        const n = selectOptions.find((f) => f.value == element || f.value === element);
        if (n != null) listanombres.push(this.getSelectOptionLabel(column, n));
      });
      filterToAdd.value = listaidstring.join(",");
      filterToAdd.show = listanombres.join(",");
    } else if (column.type == "inputFilter") {
      filterToAdd.value = this.fEdit[column.name].value;
      filterToAdd.show = column.filterOptions.selectOptions.find(
        (find) => find.value == filterToAdd?.value
      )?.name || (this.inputFilterData?.value && this.inputFilterData.name);
    } else {
      filterToAdd.value = this.fEdit[column.name].value;
      filterToAdd.show = filterToAdd.value;
    }
    filterToAdd.name = column.name;
    filterToAdd.db = column.BBDD;
    filterToAdd.filterApi = column.filterApi;
    filterToAdd.translation = column.labelTranslate;

    // if (column.type === 'inputFilter' && !this.inputFilterData.name.length) {
    //   let filterIndex = this.filters.findIndex(
    //     (find) => find.filterApi == filterToAdd.filterApi
    //   );

    //   this.removeDataInput(filterToAdd.filterApi);
    //   this.filters.splice(filterIndex, 1);
    // }

    return filterToAdd;
  }
  visibilidadFiltro(evento, seleccionfiltros) {
    if (evento != null && seleccionfiltros != null) {
      const index = this.table.columns.findIndex(
        (item) => item.name == evento.option.value
      );

      if (index === -1) {
        return;
      }

      if (evento.option.selected) {
        this.table.columns[index].filterActive = evento.option.value;
      } else {
        this.table.columns[index].filterActive = "";
        this.removeDataInput(evento.option.value);
        this.AplicarFiltros();
      }
    }
  }

  visibilidadColumna(evento, seleccionfiltros) {
    if (evento != null && seleccionfiltros != null) {
      const index = this.table.columns.findIndex(
        (item) => item.name == evento.option.value
      );
      if (index < 0) {
        return;
      }
      const col = this.table.columns[index];
      if (evento.option.selected) {
        col.columnActive = evento.option.value;
        if (
          this.tableName === "tbTiposAbonado" &&
          col.column === false &&
          col.name !== "pkId"
        ) {
          col.column = true;
        }
      } else {
        col.columnActive = "";
        if (
          this.tableName === "tbTiposAbonado" &&
          (col.name === "TipoOperacion" || col.name === "TipoProductoNombre")
        ) {
          col.column = false;
        }
      }

      this.changeColumns();
    }
  }

 
  mostrarColumnaEnSelector(columna: Column): boolean {
    if (!columna || columna.name === "pkId" || columna.type === "actions") {
      return false;
    }
    if (
      this.tableName === "tbTiposAbonado" &&
      columna.name === "ImprimirTicket"
    ) {
      return false;
    }
    if (columna.column === true) {
      return true;
    }
    if (
      this.tableName === "tbTiposAbonado" &&
      columna.column === false &&
      columna.columnActive !== undefined
    ) {
      return true;
    }
    return false;
  }

  filterLenghtWithoutAColumn() {
    if (!this.table || !this.table.columns) {
      return 0;
    }

    return this.table.columns.filter((column) =>
      this.mostrarColumnaEnSelector(column)
    ).length;
  }
  calculateClassesFiltersButton() {
    let classes: any = { displayBlock: true };
    let flag = false;
    if (this.table && this.table.columns) {
      this.table.columns.map((column) => {
        if (column.filterActive != "") {
          flag = true;
        }
      });
    }
    if (!flag) {
      classes = {
        displayNone: true,
      };
    } else {
      classes = {
        displayBlock: true,
      };
    }

    return classes;
  }
  calculateClassesFiltersTable() {
    let classes: any = { "customan-panel-filtros-tabla": true };
    let flag = false;
    if (this.table && this.table.columns) {
      this.table.columns.map((column) => {
        if (column.filterActive != "") {
          flag = true;
        }
      });
    }

    if (!flag) {
      classes = {
        "customan-panel-filtros-tabla-without-filters": true,
      };
    } else {
      classes = {
        "customan-panel-filtros-tabla": true,
      };
    }

    return classes;
  }

  clickOutSide() {
    this.renderer.listen("window", "click", (e: Event) => {
     
      if (this.panelSelectorFiltrosvisible) {
        if (
          !this.filterButtonOption.nativeElement.contains(e.target) &&
          !this.filterPanel.nativeElement.contains(e.target)
        ) {
          this.panelSelectorFiltrosvisible = false;
        }
      }

      if (this.panelColumnasvisible) {
        if (
          !this.columnPanelVisible.nativeElement.contains(e.target) &&
          !this.columnButtonOption.nativeElement.contains(e.target)
        ) {
          this.panelColumnasvisible = false;
        }
      }
    });
  }


  filterByInputFilter() {
    if (!this.table?.columns || !this.editFilterForm) {
      return;
    }
    const data = this.inputFilterData;
    const clearedControlName =
      data?.controlName &&
      data.name === "" &&
      (data.value === "" ||
        data.value === undefined ||
        data.value === null);

    this.table.columns.forEach((column) => {
      if (column.type !== "inputFilter" || !this.fEdit[column.name]) {
        return;
      }
      const element = document.getElementById(column.name) as HTMLInputElement | null;
      const elementHidden = document.getElementById(
        column.name + "-hidden"
      ) as HTMLInputElement | null;
      if (!element || !elementHidden) {
        return;
      }

      if (clearedControlName && data.controlName === column.name) {
        this.fEdit[column.name]?.setValue("", { emitEvent: false });
        this.fEdit[column.name]?.reset();
        element.value = "";
        elementHidden.value = "";
      } else {
        const hiddenVal = (elementHidden.value ?? "").trim();
        if (hiddenVal && hiddenVal !== "0" && hiddenVal !== "-1") {
          this.fEdit[column.name].setValue(hiddenVal, { emitEvent: false });
        }
      }
    });

    if (clearedControlName) {
      this.inputFilterData = {};
    }
  }
  /** Sincroniza o FormControl do filtro com o valor do `app-input-filter` (mesmo padrão que tipo abonado). */
  closeInputFilter(enventValues: { name?: string; value?: any }) {
    if (!enventValues?.name || !this.editFilterForm?.get(enventValues.name)) {
      return;
    }
    const raw = enventValues.value;
    const normalized = raw === "-1" || raw === -1 ? "" : raw;
    this.editFilterForm.get(enventValues.name).setValue(normalized);
  }

  getInputFilterValue(enventValues: {
    name?: string;
    value?: string;
    controlName?: string;
  }) {
    this.inputFilterData = { ...this.inputFilterData, ...enventValues };
  }
  
  /*   numeroCamposActivos(tablecolumns) {
    return tablecolumns.find(f => f.filter==true).lenght;
    //return tablecolumns.length;
  } */
}
